const getUsernameOrPreferredUsername = (caregiver: any) => {
  if (caregiver && caregiver.preferredUsername) return caregiver.preferredUsername;
  if (caregiver && caregiver.username) return caregiver.username;
  return 'Hospitalink';
};

export { getUsernameOrPreferredUsername };
